interface StarIconProps {
  isFill?: boolean;
}
export default function StarIcon({ isFill = false }: StarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={isFill ? "currentColor" : "none"}
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.48 3.499a.562.562 0 011.04 0l2.262 4.584a.562.562 0 00.423.308l5.05.735a.562.562 0 01.312.96l-3.655 3.564a.562.562 0
                      00-.162.497l.862 5.03a.562.562 0 01-.816.592L12 17.77l-4.512 2.37a.562.562 0 01-.816-.592l.862-5.03a.562.562 0 00-.162-.497L3.717
                      10.09a.562.562 0 01.312-.96l5.05-.735a.562.562 0 00.423-.308l2.262-4.584z"
      />
    </svg>
  );
}
